module.exports = __webpack_public_path__ + "img/Weapon_196.18a701b7.png";